goog.provide("shadow.js.shim.module$$mui$material$Button$default");
shadow.js.shim.module$$mui$material$Button$default = shadow.js.require(404, {})["default"];
